// extracted by mini-css-extract-plugin
export default {"wrapper":"SecurityAwareness_wrapper__6EA5o"};